import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

const initialState = {
    activitiesByWeek: {},
    activityIndex: {},
    createdActivityId: null,
    createdActivityGuid: "",
    createPlanDateTime: "",
    acceptedActivityId: null,
    selectedDateForActivityCreate: "",
    selectedHourForActivityCreate: "",
    selectedActivity: "",
    selectedActivityStatements: ""
}

const activitySlice = createSlice({
    name: 'activity',
    initialState,
    reducers: {
        setCreatedActivityId(state, action) {
            if (action.payload === undefined) {
                state.createdActivityId = null;
                state.createdActivityGuid = "";
                state.createPlanDateTime = "";
            } else {
                state.createdActivityId = action.payload.activityId;
                state.createdActivityGuid = action.payload.guid;
                state.createPlanDateTime = action.payload.planDateTime;
            }
        },



        setActivities(state, action) {
            let { activities, key } = action.payload;
            if (!state.activitiesByWeek) state.activitiesByWeek = {};
            if (!state.activityIndex) state.activityIndex = {};

            // burada array formunda gelen statement listesini
            // map'e donusturuyoruz. surekli bu elemanlara erismemiz gerekecek
            // array icinde bulmaya calismak liste boyutu arttikca performans
            // sorunlarina neden olacaktir.
            if (state.activitiesByWeek[key] != undefined && state.activitiesByWeek[key].length > 0 && !action.payload.isFromReload) {
                const newItem = activities.filter((f) => { return !state.activitiesByWeek[key].includes(f.guid) }).map((m) => m.guid);// Var olanları tekrar eklemesin..
                state.activitiesByWeek[key] = [...state.activitiesByWeek[key], ...newItem];
            } else {
                state.activitiesByWeek[key] = [...activities.map(a => a.guid)];
            }

            activities.forEach((api_activity) => {
                let client_activity = { ...api_activity, activityStatementIndex: {} };
                delete (client_activity).activityStatements;
                delete (client_activity).__typename;

               //testiki
                if (api_activity.activityStatements) {
                    api_activity.activityStatements.forEach(st => {
                        client_activity.activityStatementIndex[st.activityStatementId] = st;


                    });
                }

                state.activityIndex[client_activity.guid] = client_activity;
            });
        },
        setSelectedActivities(state, action) {
            state.selectedActivity = action.payload
        },
        setSelectedActivitiesStatements(state, action) {
            state.selectedActivityStatements = action.payload

        }

    }
});


export const {
    setActivities,
    setCreatedActivityId,
    setSelectedActivities,
    setSelectedActivitiesStatements
} = activitySlice.actions;

export default activitySlice.reducer;
